const CustomFieldSelector = ({
  handleOnChange,
  options,
  value,
  operatorSelector,
  valueEditor,
}) => {
  const groupedOptions = options.reduce((acc, field) => {
    if (!acc[field.category]) acc[field.category] = [];
    acc[field.category].push(field);
    return acc;
  }, {});

  return (
    <>
      <select
        className="form-control"
        value={value}
        onChange={(e) => {
          handleOnChange(e.target.value);
        }}
      >
        <option value="">-----</option>
        {Object.entries(groupedOptions).map(([category, fields]) => (
          <optgroup key={category} label={category}>
            {fields?.map((field) => (
              <option key={field.name} value={field.name}>
                {field.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </>
  );
};
export default CustomFieldSelector;
